import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import IMAGES_PATH from '../../../Images'
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import TitleWithIcon from '../../common/TitleWithIcon'
import './style.css'
import { useNavigation } from '../../../hooks/useNavigate';

export const SectionProgressBar = () => {

    const firstTitlePart = <h2>{t(TEXT_KEYS.HOME_PROGRESS_BAR_TITLE_1)}</h2>;
    const secondTitlePart = <h2>{t(TEXT_KEYS.HOME_PROGRESS_BAR_TITLE_2)}</h2>;
    const thirdTitlePart = <h2 className='text-blue'>{t(TEXT_KEYS.HOME_PROGRESS_BAR_TITLE_3)}</h2>;

    const {
        goToSupport
    } = useNavigation()

    return (
        <div className='section'>
            <div className='section-porgress-bar-header'>
                <h4 className='text-blue section-porgress-bar-header-subtitle'>{t(TEXT_KEYS.HOME_PROGRESS_BAR_SUBTITLE)}</h4>
                <TitleWithIcon
                    imagePath={IMAGES_PATH.ICON_PERCENT}
                    firstTitlePart={firstTitlePart}
                    secondTitlePart={secondTitlePart}
                    thirdTitlePart={thirdTitlePart}
                />
            </div>
            <div className='section-progress-bar-body'>
                <div className='section-progress-bar-bar'>
                    <div className='progress-bar-item-active' />
                    <div className='progress-bar-item-active' />
                    <div className='progress-bar-item-active' />
                    <div className='progress-bar-item-inactive' />
                    <div className='progress-bar-item-inactive' />
                </div>
                <div className='section-progress-bar-step'>
                    <h4 className='text-blue'>{t(TEXT_KEYS.HOME_PROGRESS_BAR_CURRENT_STEP)}</h4>
                    <h4 className='text-grey'>{t(TEXT_KEYS.HOME_PROGRESS_BAR_NEXT_STEP)}</h4>
                </div>
            </div>
            <div className='section-progress-bar-button'>
                <Button
                    label={t(TEXT_KEYS.HOME_PROGRESS_BAR_BUTTON)}
                    onClick={goToSupport}
                />
            </div>
        </div>
    )
}

export default SectionProgressBar